var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false, title: "现金流量表" } },
        [
          _c(
            "div",
            { staticClass: "period-bar" },
            [
              _c("a-button", {
                attrs: { size: "small", icon: "left" },
                on: {
                  click: function ($event) {
                    return _vm.shiftPeriod(-1)
                  },
                },
              }),
              _c("span", { staticClass: "period-text" }, [
                _vm._v(_vm._s(_vm.periodLabel)),
              ]),
              _c("a-button", {
                attrs: { size: "small", icon: "right" },
                on: {
                  click: function ($event) {
                    return _vm.shiftPeriod(1)
                  },
                },
              }),
              _c("a-month-picker", {
                staticStyle: { "margin-left": "12px" },
                attrs: {
                  value: _vm.periodMoment,
                  format: "YYYY-MM",
                  allowClear: false,
                },
                on: { change: _vm.onPeriodChange },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "12px",
                    display: "inline-block",
                    width: "180px",
                  },
                },
                [
                  _c("store-tenant-select", {
                    attrs: { domain: "finance" },
                    on: { change: _vm.handleStoreTenantChange },
                  }),
                ],
                1
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "12px" },
                  attrs: { icon: "reload" },
                  on: { click: _vm.searchQuery },
                },
                [_vm._v("刷新")]
              ),
              _c(
                "a-button",
                {
                  staticClass: "float-right",
                  attrs: { icon: "setting" },
                  on: { click: _vm.editItems },
                },
                [_vm._v("编辑数据项")]
              ),
            ],
            1
          ),
          _c(
            "a-tabs",
            {
              on: { change: _vm.onTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("a-tab-pane", { key: "cashflow", attrs: { tab: "主表" } }),
              _vm.showSuppTab
                ? _c("a-tab-pane", {
                    key: "cashflow_supp",
                    attrs: { tab: "补充资料" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("a-spin", { attrs: { spinning: _vm.loading } }, [
            _c(
              "div",
              {
                staticClass: "scroll-wrap",
                style: {
                  maxHeight: _vm.scrollHeight + "px",
                  overflowY: "auto",
                },
              },
              [
                _c("table", { staticClass: "cf-table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("项目")]),
                      _c("th", { staticClass: "cf-rowno" }, [_vm._v("行次")]),
                      _c("th", { staticClass: "cf-amt" }, [_vm._v("本期金额")]),
                      _c("th", { staticClass: "cf-amt" }, [
                        _vm._v("本年累计金额"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.displayRows, function (it, idx) {
                        return [
                          it.row.isGroup === "1"
                            ? _c(
                                "tr",
                                { key: "g" + idx, staticClass: "cf-group" },
                                [
                                  _c(
                                    "td",
                                    {
                                      style: _vm.indentStyle(it.row),
                                      attrs: { colspan: 4 },
                                    },
                                    [
                                      it.row.folded === "1" && it.hasChildren
                                        ? _c("a-icon", {
                                            staticClass: "fold-toggle",
                                            attrs: {
                                              type: _vm.foldIcon(it.row),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleFold(it.row.id)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "cf-bold": it.row.bold === "1",
                                          },
                                        },
                                        [_vm._v(_vm._s(it.row.name))]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _c(
                                "tr",
                                {
                                  key: "r" + it.row.id,
                                  class: { "cf-bold": it.row.bold === "1" },
                                },
                                [
                                  _c(
                                    "td",
                                    { style: _vm.indentStyle(it.row) },
                                    [
                                      it.row.folded === "1" && it.hasChildren
                                        ? _c("a-icon", {
                                            staticClass: "fold-toggle",
                                            attrs: {
                                              type: _vm.foldIcon(it.row),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleFold(it.row.id)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(it.row.name) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("td", { staticClass: "cf-rowno" }, [
                                    _vm._v(_vm._s(it.row.rowNo)),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "cf-amt",
                                      class: { neg: _vm.isNeg(it.row.amount1) },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.fmtAmount(it.row.amount1))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "cf-amt",
                                      class: { neg: _vm.isNeg(it.row.amount2) },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.fmtAmount(it.row.amount2))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ]
                      }),
                      !_vm.loading && !_vm.displayRows.length
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  color: "#999",
                                },
                                attrs: { colspan: "4" },
                              },
                              [_vm._v("暂无数据")]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            ),
          ]),
          _vm.checks.length
            ? _c(
                "div",
                { staticStyle: { "margin-top": "12px" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "600",
                        "margin-bottom": "4px",
                      },
                    },
                    [_vm._v("勾稽校验")]
                  ),
                  _vm._l(_vm.checks, function (c, i) {
                    return _c(
                      "div",
                      { key: "ck" + i, staticStyle: { "line-height": "22px" } },
                      [
                        _c("span", { class: c.ok ? "cf-ok" : "neg" }, [
                          _vm._v(_vm._s(c.ok ? "√" : "×")),
                        ]),
                        _vm._v(" " + _vm._s(c.name)),
                        !c.ok
                          ? [
                              _vm._v(
                                "（预期 " +
                                  _vm._s(_vm.fmtCheck(c.expected)) +
                                  " / 实际 " +
                                  _vm._s(_vm.fmtCheck(c.actual)) +
                                  "）"
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.unassignedHint
            ? _c(
                "div",
                { staticClass: "neg", staticStyle: { "margin-top": "8px" } },
                [
                  _vm._v(_vm._s(_vm.unassignedHint) + "\n      "),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.backfilling,
                      },
                      on: { click: _vm.backfillTags },
                    },
                    [_vm._v("补录标签")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeTab === "cashflow"
            ? _c("a-alert", {
                staticStyle: { "margin-top": "12px" },
                attrs: {
                  type: "info",
                  "show-icon": "",
                  message:
                    "归类规则：资金类科目分录通过「现金流」辅助核算项目归类（凭证录入时按对方科目智能推荐，映射规则可在 凭证规则→现金流映射 中维护）；未指定现金流项目的资金分录计入未分配现金流量",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }